(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-template"]) return;
  try {
    
$(function(){
    $('.tab-title').click(function(){
        $(this).toggleClass('active');
        $(this).children('.la-plus').toggle();
        $(this).siblings('.tab-content').toggle();
    })
});

  } catch(e) { console.error(e); }
})();
})();
